import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

// Create axios instance with interceptors from authService
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Employee service functions
export const employeeService = {
  // Get all employees with filters and pagination
  async getEmployees(params = {}) {
    try {
      console.log('🔄 Fetching employees with params:', params);
      const response = await api.get('/employees', { params });
      console.log('✅ Employees fetched:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Get employees error:', error);
      throw new Error(error.response?.data?.error || 'Failed to fetch employees');
    }
  },

  // Get single employee by ID
  async getEmployee(id) {
    try {
      console.log('🔄 Fetching employee:', id);
      const response = await api.get(`/employees/${id}`);
      console.log('✅ Employee fetched:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Get employee error:', error);
      throw new Error(error.response?.data?.error || 'Failed to fetch employee');
    }
  },

  // Create new employee
  async createEmployee(employeeData) {
    try {
      console.log('🔄 Creating employee:', employeeData);
      const response = await api.post('/employees', employeeData);
      console.log('✅ Employee created:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Create employee error:', error);
      
      // Handle validation errors specifically
      if (error.response?.status === 400 && error.response?.data?.error === 'Validation failed') {
        const validationError = new Error('Validation failed');
        validationError.response = error.response;
        throw validationError;
      }
      
      throw new Error(error.response?.data?.error || 'Failed to create employee');
    }
  },

  // Update employee
  async updateEmployee(id, employeeData) {
    try {
      console.log('🔄 Updating employee:', id, employeeData);
      const response = await api.put(`/employees/${id}`, employeeData);
      console.log('✅ Employee updated:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Update employee error:', error);
      
      // Handle validation errors specifically
      if (error.response?.status === 400 && error.response?.data?.error === 'Validation failed') {
        const validationError = new Error('Validation failed');
        validationError.response = error.response;
        throw validationError;
      }
      
      throw new Error(error.response?.data?.error || 'Failed to update employee');
    }
  },

  // Delete employee (soft delete)
  async deleteEmployee(id) {
    try {
      console.log('🔄 Deleting employee:', id);
      const response = await api.delete(`/employees/${id}`);
      console.log('✅ Employee deleted:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Delete employee error:', error);
      throw new Error(error.response?.data?.error || 'Failed to delete employee');
    }
  },

  // Get employee statistics
  async getEmployeeStats() {
    try {
      console.log('🔄 Fetching employee statistics');
      const response = await api.get('/employees/stats');
      console.log('✅ Employee stats fetched:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Get employee stats error:', error);
      throw new Error(error.response?.data?.error || 'Failed to fetch employee statistics');
    }
  }
};

export default employeeService; 